import React from "react";
import { withRouter } from "react-router-dom";
import { flowRight as compose } from 'lodash';
import { withStore } from "../../store";
import { SVG } from "../../assets/images";
import { getClientApiURL } from "../../utils"
import "./SubscribersOptions.scss";
import { MET_MAIN_SITE_URL } from "../../config/metMainSite";

// MET2-2866: the "Hi, <name>" account dropdown over the hero. Restored to the
// original design (dark panel, white uppercase links) AND made keyboard
// accessible per the ticket AC: a logged-in keyboard user can Tab to the
// trigger, open it with Enter/Space, Tab through every option, and press
// Escape to close it and return focus to the trigger.
class SubscribersOptions extends React.Component<any, any> {
  triggerRef: React.RefObject<HTMLButtonElement>;
  containerRef: React.RefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.state = { open: false };
    this.triggerRef = React.createRef();
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.onDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onDocumentClick);
  }

  // Outside-click closes the menu.
  onDocumentClick = (e) => {
    if (this.state.open && this.containerRef.current && !this.containerRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  toggle = () => {
    this.setState((s) => ({ open: !s.open }));
  }

  close = (returnFocus?: boolean) => {
    this.setState({ open: false });
    if (returnFocus && this.triggerRef.current) this.triggerRef.current.focus();
  }

  // Escape closes the menu and returns focus to the trigger.
  onKeyDown = (e) => {
    if (e.key === "Escape" && this.state.open) {
      e.stopPropagation();
      this.close(true);
    }
  }

  onLogOut = () => {
    const logout = fetch(`${getClientApiURL("/logout")}`, { credentials: "include" })
    logout.then(response => {
      if (response.status === 200) {
        this.props.handleLogout();
      }
    });
  }

  render() {
    const { store: { user, userFetchPending } } = this.props;
    if (userFetchPending || !user) return null;

    const isStudent = user.data && user.institutionName;
    // Marketing/account links point at the Met main site, the same host the
    // redesigned header uses (config/headerConfig.ts). The host comes from
    // REACT_APP_MET_MAIN_SITE_URL; REACT_APP_METOPERA_BASE_URL is reserved for
    // the Tessitura purchase flow, not these.
    const metoperaBaseUrl = MET_MAIN_SITE_URL;
    const name = (user.data && user.institutionName) || (user.data && user.data.LoginInfo && user.data.LoginInfo.salutation);
    const { open } = this.state;

    // Students have no dropdown — just the account name.
    if (isStudent) {
      return (
        <div className="SubscribersOptions option-list-hidden">
          <div className="SubscribersOptions-container">
            <span className="SubscribersOptions-title cursor-default">{name}</span>
          </div>
        </div>
      );
    }

    return (
      <div className={`SubscribersOptions ${open ? "" : "option-list-hidden"}`}>
        <div className="SubscribersOptions-container" ref={this.containerRef} onKeyDown={this.onKeyDown}>
          <button
            type="button"
            ref={this.triggerRef}
            className="SubscribersOptions-title"
            // MET2-2909 AC Scenario 2 wants the four options announced as plain
            // links, no menu semantics. aria-haspopup="true" is defined as
            // haspopup="menu", so it promised a menu that does not exist here
            // (the options are a <ul> of links and a Logout button, with no
            // menuitem roles and no arrow-key menu navigation). aria-expanded
            // plus aria-controls already convey the disclosure state, which is
            // the correct pattern for this widget.
            aria-expanded={open}
            aria-controls="subscriber-options-list"
            onClick={this.toggle}
          >
            Hi, {name}
            <SVG.ArrowDown className="SubscribersOptions-arrow" aria-hidden="true" />
          </button>
          <ul id="subscriber-options-list" className="SubscribersOptions-options-list">
            <li><a href={`${metoperaBaseUrl}/account/manage-on-demand-subscription/`} onClick={() => this.close()}>Your Subscription</a></li>
            <li><a href={`${metoperaBaseUrl}/season/on-demand/met-opera-on-demand-faq/`} onClick={() => this.close()}>Help/FAQs</a></li>
            <li><a href={`${metoperaBaseUrl}/season/on-demand/gift-subscriptions/`} onClick={() => this.close()}>Gift Subscriptions</a></li>
            <li><button type="button" className="SubscribersOptions-logout" onClick={this.onLogOut}>Logout</button></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default compose(withRouter, withStore)(SubscribersOptions);
